import type { IWatermarkElement } from '@/types/watermarks.types';
import { WatermarkElementTypes } from '@/types/watermarks.types';
import { useState, useRef, useEffect } from 'react';
import TextEl from './text';
import { formatWatermarkDate, formatWatermarkTime, formatWatermarkDateTime } from '../utils/format-watermark-date';

const formatters = {
  [WatermarkElementTypes.date]: formatWatermarkDate,
  [WatermarkElementTypes.time]: formatWatermarkTime,
  [WatermarkElementTypes.datetime]: formatWatermarkDateTime,
};

const DateTimeEl = (el: IWatermarkElement) => {
  const format = formatters[el.type as keyof typeof formatters];
  const [value, setValue] = useState(() => format());
  const interval = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setValue(format());

    interval.current = setInterval(() => {
      setValue(format());
    }, 60000);

    return () => {
      if (interval.current) clearInterval(interval.current);
    };
  }, [format]);

  return <TextEl {...el} settings={{ ...el.settings, text: { ...el.settings.text, value } }} />;
};

export default DateTimeEl;
